import React from 'react'
import Layout from './Layout'
import Products from './Products'
import Transactions from './Transactions'
import PurchaseOrders from './PurchaseOrders';
import Reports from './Reports';
import LoanProgram from './LoanProgram';
import LoanProgramItem from './LoanProgramItem';
import LoanProgramSerialNumber from './LoanProgramSerialNumber';
import Report from './Report';
import Vendors from './Vendors';
import Ops from './Ops';
import OpsEdit from './OpsEdit';
import Kits from './Kits';
import Locations from './Locations';

import {
  createRoutesFromElements,
  createBrowserRouter,
  Route,
  RouterProvider,
  useRouteError,
} from "react-router-dom";

const Error = () => {
  const error = useRouteError();
  return <>
    <h1 className="text-4xl mb-6">Oh no! Something went horribly wrong.</h1>
    <p>You should probably send Josh a short summary of what you were trying to do and the following details:</p>
    <p>{error.message}</p>
  </>
}

const routes = createRoutesFromElements(
  <Route path="/" element={<Layout />}>
    <Route errorElement={<Error />}>
      <Route index element={<Products />} />
      <Route path="kits" element={<Kits />} />
      <Route path="locations" element={<Locations />} />
      <Route path="transactions" element={<Transactions />} />
      <Route path="purchase-orders" element={<PurchaseOrders />} />
      <Route path="reports">
        <Route index element={<Reports />} />
        <Route path=":id" element={<Report />} />
      </Route>
      <Route path="vendors" element={<Vendors />} />
      <Route path="loan-program">
        <Route index element={<LoanProgram />} />
        <Route path=":id" element={<LoanProgramItem />} />
        <Route path=":item_id/serial-number/:id" element={<LoanProgramSerialNumber />} />
      </Route>
      <Route path="ops">
        <Route index element={<Ops />} />
        <Route path=":id/edit" element={<OpsEdit />} />
      </Route>
    </Route>
  </Route>
)

const router = createBrowserRouter(routes)

export default function () {
  return (
    <RouterProvider router={router} />
  )
}
